import nodeClient from "./node-client";

export const saveEntity = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/entityMaster/add`,
    payload
  );
  return response?.data;
};
export const listEntity = async (payload) => {
  const response = await nodeClient.post(
    `/service/protected/v0/entityMaster/list`,
    payload
  );
  return response?.data;
};
